import MDBox from "components/MDBox";
import { ReactNode } from "react";
import UiTypography from "components/base/UiTypography";

type LabeledValueProps = {
  label: ReactNode;
  value: string;
  labelWidth?: string;
  boldValue?: boolean;
};

export default function LabeledValue({
  label,
  value,
  labelWidth = "148px",
  boldValue = false,
}: LabeledValueProps) {
  return (
    <MDBox display="flex" flexDirection="row" alignItems="baseline" gap="10px">
      <UiTypography
        component="span"
        uiVariant="label"
        sx={{ width: labelWidth, flexShrink: 0, lineHeight: 1, m: 0, p: 0 }}
      >
        {label}
      </UiTypography>
      <UiTypography
        component="span"
        uiVariant="body"
        sx={{ lineHeight: 1, fontWeight: boldValue ? 600 : 400, m: 0, p: 0 }}
      >
        {value}
      </UiTypography>
    </MDBox>
  );
}
